<template>
  <div class="page">
    <div class="top-logo" @click="$gopage('index')">
      <img src="~images/logo-login.png" />
      <span>朗朗书声</span>
    </div>
    <div class="container">
      <div class="login-box">
        <div class="title">
          <h2>老师，请您登录</h2>
          <div class="tip">朗朗书声语文朗读教学平台（诵读资源库）</div>
        </div>
        <div class="form-box">
          <div class="form-item">
            <FInput @enter="submit" ref="mobile" v-model="formData.mobile" :maxlength="11" type="text"
              placeholder="请输入手机号" />
          </div>
          <div class="form-item mrb0">
            <FInput @enter="submit" ref="pwd" v-model="formData.pwd" :maxlength="16" type="password"
              placeholder="请输入密码" />
          </div>
          <div class="form-item form-item-forget">
            <a class="forget" @click="$gopage('forget')">忘记密码</a>
          </div>
          <button class="btn btn-act" @click="submit" :class="{ 'btn-disabled': !isCanClick }">
            登录
          </button>
          <div class="reg-tip">
            还没有账号？ 请&nbsp;<a @click="goRegister">注册</a>
          </div>
          <div class="login-tip">
            如果您已经是【朗朗书声
            统编人教语文朗读指导】小程序注册用户，请直接使用原手机账号/密码登录本平台
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="rcwebEnter">
      <img
        class="rcwebImg"
        src="https://reading.oss.iyougu.com/rcweb/image/2023-04-07/2182b922f8214e32b3e5e89db1f28c91.png"
      />
      <div class="rcwebText" @click="gotoOrga">
        我已开通机构，使用
        <div class="orgaText">机构版登录</div>
      </div>
    </div> -->

    <div class="footer">
      <div class="copy">
        Copyright @ 2020 朗朗书声 All Right Reserved 京ICP备19040061号
      </div>
      <div class="wj">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040926"
          style="display: inline-block">
          <img src="~images/icon-wj.png" style="float: left" />
          <p style="
              float: left;
              height: 20px;
              line-height: 20px;
              margin: 0px 0px 0px 5px;
            ">
            京公网安备 11010502040926号
          </p>
        </a>
      </div>
      <div class="wj">
        <a target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch?code=1101050205832"
          style="display: inline-block">
          <img src="~images/icon-wj.png" style="float: left" />
          <p style="
              float: left;
              height: 20px;
              line-height: 20px;
              margin: 0px 0px 0px 5px;
            ">
            京公网安备 11010502058323号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import FInput from "base/input/index";
import Vue from "vue";
import md5 from "md5";
import util from "libs/util";

export default {
  components: {
    FInput,
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  data() {
    return {
      isCanClick: false,
      formData: {
        mobile: "",
        pwd: "",
      },
    };
  },
  watch: {
    formData: {
      handler(newVal) {
        if (newVal.mobile && newVal.pwd) {
          this.isCanClick = true;
        } else {
          this.isCanClick = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    Vue.prototype.$isToLogin = 0;
  },
  methods: {
    gotoOrga() {
      // window.location.href = "https://trcweb.ygr.iyougu.com/#/";
      const isTest = location.host.indexOf("test") > -1;
      const isLocalhost = location.host.indexOf("localhost") > -1;
      if (isTest || isLocalhost) {
        window.location.href = "https://trcweb.ygr.iyougu.com/#/";
      } else{
        window.location.href = "https://rcweb.iyougu.com/#/"
      }
    },
    goRegister() {
      let query = this.$route.query;
      this.$gopage("register", query);
    },
    async submit() {
      const formData = this.formData;
      if (!this.isCanClick) {
        return;
      }
      const config = [
        {
          id: "mobile",
          rule: {
            required: {
              message: "请输入手机号码",
            },
            mobile: {
              message: "请输入正确的手机号码",
            },
          },
        },
        {
          id: "pwd",
          rule: {
            required: {
              message: "请输入密码",
            },
          },
        },
      ];
      let { result, params } = await this.$checkForm(config, formData);
      if (!result) {
        return;
      }
      params.pwd = md5(params.pwd);
      this.$loading.show();
      const res = await this.$post("/passport/login.json", params);
      const query = this.$route.query;
      this.$loading.hide();
      if (res.status == 200) {
        this.formData = {
          mobile: "",
          pwd: "",
        };
        await this.$store.dispatch("queryUserInfo");
        this.$user.loginCallBack(query);
      } else {
        this.$toast(res.message);
      }
    },
    async mobileDone(userInfo) {
      const query = this.$route.query;
      if (this.$user.isNeedBind(userInfo)) {
        this.$gopage(
          "bindMobile",
          {
            mobile: userInfo.webUser.userTel,
            ...query,
          },
          true
        );
      } else {
        await this.$store.dispatch("queryUserInfo");
        this.$user.loginCallBack(query);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import '~styles/mixin';
@import '~styles/var';
.page {
  .top-logo {
    width: 168px;
    height: 48px;
    display: flex;
    align-items: center;
    position: absolute;
    left: 36px;
    top: 15px;
    cursor: pointer;
    span {
      color: #fff;
      font-size: 18px;
      padding-left: 15px;
    }
  }
  .container {
    height: 100%;
    .bg-url('~images/login-bg.png');
    background-size: cover;
    background-position: center center;
  }
  // .cont{
  //   width: 500px;
  //   position: absolute;
  //   left: 50%;
  //   top: 50%;
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: center;
  //   align-items: center;
  //   transform: translate(-50%, -50%);
  // }
  .login-box {
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    border-radius: 54px;
    background: #fff;
    overflow: hidden;
    font-size: 16px;
    width: 500px;
    box-sizing: border-box;
    position: relative;

    .bindTit{
      text-align: center;
      padding-top: 30px;
      color: #666666;
      font-size: 16px;
    }
    .scanLog{
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      width: 112px;
      height: 109px;
      .bg-url('~images/scanLog.png');
      background-size: 100% 100%;
      justify-content: center;
      padding: 0 0 24px 16px;
      box-sizing: border-box;;
      color: #fff;
      font-size: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .icon{
        width: 53px;
        height: 53px;
      }
      .phonI{
        width: 40px;
        height: 40px;
        margin-bottom: 5px;
      }
      span{
        margin-top: -10px;
      }
    }
    .title {
      background: #F6F6F6;
      padding: 30px 50px;
      text-align: center;
      h2 {
        font-size: 32px;
        color: #333;
      }
      .tip {
        color: #999;
        margin-top: 5px;
      }
    }
    .form-box {
      padding: 0 50px 40px;
      .form-item {
        margin-top: 40px;
        /deep/ .f-input {
          border-bottom: solid 1px #EEEEEE
        }
        &.form-item-forget {
          margin-top: 11px;
          text-align: right;
          color: #999;
        }
        &.form-item-vcode {
          display: flex;
          align-items: flex-end;
          .item-code {
            flex: 1;
          }
          .btn-code {
            width: 90px;
            text-align: center;
            color: @theme;
            display: flex;
            align-items: center;
            justify-content: center;
            &.disabled {
              color: #CCCCCC;
              border-color: rgba(204, 204, 204, 1);
            }
          }
        }
      }
      .btn-act {
        height: 44px;
        display: block;
        line-height: 44px;
        background: #81CB44;
        border-radius: 100px;
        width: 100%;
        margin-top: 40px;
        &.btn-disabled {
          background: #ddd;
          opacity: 1;
          cursor: default;
        }
        &.btn-confirm {
          margin-top: 40px;
        }
      }

      .bindTips{
        color: #666666;
        font-size: 12px;
        padding: 12px 54px 0;
        text-align: center;
        
        .xin{
          color: #FF5C5C;
          font-size: 12px;
        }
          
      }
    }
    .reg-tip {
      margin-top: 20px;
      color: #ccc;
      text-align: center;
      a {
        color: @theme;
      }
    }
    .private {
      margin-top: 20px;
      color: #999;
      text-align: center;
      a {
        display: inline-block;
        color: @theme
      }
    }
  }

  .codeBox{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 44px 0;
    color: #333333;
    font-size: 16px;

    .wrap{
      position: relative;
      width: 200px;
      height: 200px;
      margin-bottom: 20px;
      .maskBox{
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        top: 0;
        left: 0;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        p{
          font-size: 11px;
        }
        .iconfont {
          font-size: 40px;
          margin-bottom: 20px;
        }
      }
    }

    .codeImg{
      width: 200px;
      height: 200px;
    }
  }
  .login-tip {
    padding: 16px 47px;
    text-align: center;
    color: #666666;
    font-size: 16px;
  }
  .rcwebEnter{
    // width: 100%;
    position: absolute;
    bottom: 112px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    display: flex;
    align-items: center;
    font-size: 16rpx;
    font-family: 'PingFangSC-Regular, PingFang SC';
    font-weight: 400;
    color: #7B3A0A;
    .rcwebImg{
      width: 21px;
      height: 23px;
      margin-right: 5px;

    }
    .rcwebText{
      display: flex;
      .orgaText{
        font-size: 16rpx;
        font-family: 'PingFangSC-Medium, PingFang SC';
        font-weight: 500;
        color: #FB7C33;
        margin-left: 3px;
        text-decoration:underline;
        cursor: pointer;
      }
    }
  }
  .footer {
    position: absolute;
    bottom: 30px;
    width: 100%;
    color: #A0D35E;
    text-align: center;
    line-height: 17px;
    .copy {

    }
    .wj {
      margin-top: 5px;
    }
  }
}

</style>